import axios from '../axios';

export const fetchAllPlaylist = (payload) => axios.post('/playlist', payload);

export const createPlaylist = (payload) => axios.post('/playlist/create-new', payload);

export const deletePlaylist = (id) => axios.delete(`/playlist/${id}`);

export const fetchPlaylistById = (id) => axios.get(`/playlist/${id}`);

export const getPlaylistImageUploadUrl = (id, payload) => axios.post(`/playlist/${id}/get-image-upload-url`, payload);

export const uploadPlaylistImage = (id, payload) => axios.post(`/playlist/${id}/upload-image`, payload);

export const updatePlaylist = (id, payload) => axios.post(`/playlist/${id}`, payload);

export const copyPlaylist = (id, payload) => axios.post(`/playlist/${id}/copy`, payload);

